import Panel from "./Panel";
import withExtend from "./withExtend";

export default withExtend(Panel);
